import React from 'react' // eslint-disable-line

import styled from 'styled-components'
export const InitialLoad = styled.h2`
  color: ${(props) => props.theme.colors.default};
  font-size: ${(props) => props.theme.fontSizes[6]}px;
  font-weight: 400;
  text-align: center;
  width: 100%;
  margin: ${(props) => props.theme.space[5]}px auto;
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    font-size: ${(props) => props.theme.fontSizes[5]}px;
    margin: ${(props) => props.theme.space[5]}px auto;
  }
`